@if (!props.readonly) {
  <p-divider [dt]="props.dt?.components?.divider" />
}
